import React from "react";
import getstarted from "../../../../assets/images/get-started-signup.jpg";

const SignUp = () => {
  return (
    <div className="sign-up-container">
      <div className="get-started">
        <span>Get Started</span>
        <span>
          Fill out the form to connect quickly with the right resources and
          enjoy flexible, dependable service every time.
        </span>
        <button className="sign-up-button">Signup with Zowo</button>
      </div>
      <div className="get-started-image">
        <img src={getstarted}></img>
      </div>
    </div>
  );
};

export default SignUp;
